import React,{Component} from 'react';
import {Helmet} from "react-helmet";

import Navbar from '../../components/Navbar';
import Testimony from '../../components/Testimony';
import Feature from '../../components/Feature';
import Hero from '../../components/Hero';
import {Footer1} from '../../components/Footer';

import laptop from '../../assets/images/screen_2x.png'

export default class CircleContainer extends Component{
    componentWillMount(){
        window.scroll(0,0)
    }
    render(){
        return(
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>FEATURES - Fitur dan Layanan Platform Influencer Marketing Terbaik</title>            
                    <meta name="description" content="SOSIAGO memiliki banyak fitur dan layanan menarik untuk membantu aktivitas promosi brand/produk Anda melalui Influencer marketing. Tingkatkan awarenes bisnis Anda sekarang."/>
                    {
                        (window.location.hostname === "m.sosiago.id") &&
                            <link rel="canonical" href={`https://www.sosiago.id${window.location.pathname}`} />

                    }
                </Helmet>
                <Navbar isDefault={true}/>
                <Hero                               
                    isCenterImage = {true}
                    imgSrc={laptop}
                    // title='Dapatkan Fitur-Fitur Terbaik untuk Mendukung Aktivitas Campaign Anda'                    
                    title={<h3 style={{textTransform: 'unset'}}>Dapatkan Fitur-Fitur Terbaik untuk Mendukung Aktivitas Campaign Anda</h3>}
                    subHeading = 'SosiaGo mampu memberikan solusi terbaik untuk mencari influencer yang tepat dan memonitor performance campaign Anda.'/>                        
                <Feature />
                <Testimony                     
                    title="Kenali Lebih Jauh Fitur Terbaik Kami"
                    subHeading="Berbagai macam fitur yang akan sangat memudahkan aktifitas sponsored post Anda."
                    testimony={[]}
                    isButton={true}     
                    url="/contact"   
                    buttonText="REQUEST MEETING"/>
                <Footer1 />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Features/index.js